import { billingScheduleHomeLoader } from './billingScheduleHome.loader'
import { BillingScheduleHome } from './view/BillingScheduleHome.root'
import { Navigate, useLocation } from 'react-router-dom'
import { ProtectedRoute } from 'lib/rbac'

/**
 * Retain the search param when redirecting, so we don't lose some
 * useful gubbins such as a default customerId!
 * @param props
 * @returns
 */
const RedirectWithSearch = (props: { to: string }) => {
  const { search } = useLocation()
  return <Navigate to={`${props.to}${search}`} replace />
}

export const billingScheduleHomeRoutes = [
  {
    path: ':id',
    loader: billingScheduleHomeLoader,
    element: (
      <ProtectedRoute permission="org.billing:read">
        <BillingScheduleHome />
      </ProtectedRoute>
    )
  },
  {
    path: 'new',
    exact: true,
    element: <RedirectWithSearch to="/billing-schedules/new/edit" />
  }
]
